import React from 'react';
import ClassPeriodOfferingsComponent from "./ClassPeriodOfferingsComponent";
import {padCalendar} from "../../../util";

const formatClassPeriodOfferings = (classPeriodOfferings) => {
	let classPeriodOfferingsNew = classPeriodOfferings.filter(item => item.offeringType !== "Filing"); // Removes 3

	for (const classPeriodOffering of classPeriodOfferingsNew) {
		classPeriodOffering.date = padCalendar(classPeriodOffering.offeringDate);
	}

	
	return classPeriodOfferingsNew;
};

const ClassPeriodTradingStatContainer = (props) => {
	if (!props.classPeriodOfferings) {
		return <div>Loading</div>
	}

	const data = formatClassPeriodOfferings(props.classPeriodOfferings);

	return (
		<React.Fragment>
			<ClassPeriodOfferingsComponent classPeriodOfferings={data} />
		</React.Fragment>
	);

};


export default ClassPeriodTradingStatContainer;


// WEBPACK FOOTER //
// ./src/common/components/ClassPeriodOfferings/ClassPeriodOfferingsContainer.js